const INIT = 'INIT'
const IN_PROGRESS = 'IN_PROGRESS'
const FINISHED = 'FINISHED'

export default {
  INIT: INIT,
  IN_PROGRESS: IN_PROGRESS,
  FINISHED: FINISHED
}
